import React, {useRef, useState, useEffect} from "react";
import {useParams} from "react-router-dom";
import { Button } from 'primereact/button';
import {marketingStockAPI} from "../../../api/api";
import {Galleria} from "primereact/galleria";
import {Image} from "react-bootstrap";
import {Toast} from "primereact/toast";
import {GetDateFromString} from '../../../common/Helpers/jsHelpers'
import styles from "./MarketingStockPage.module.css";
import noPhoto from "../../../common/image/no photo stub.jpg"
import { SpinnerUA } from "../../../common/Spinners/SpinerUA/SpinnerUA";
import _ from "lodash";
import { MarketingStockCalculator } from "../MarketingStockCalculator/MarketingStockCalculator";
import { MarketingStockSetWrapper } from "./MarketingStockSetWrapper/MarketingStockSetWrapper";
import {MarketingStockProductMobileView} from "../MarketingStockProduct/MarketingStockProductMobileView";
import {MarketingStockReportWrapper} from "../../MarketingStockReport/MarketingStockReportWrapper"
import {useWindowDimensions} from "../../../Context/WindowDimensionsContext";
import {useCartContext} from "../../../Context/CartContext";
import {ShellPremiumClubName} from '../../MarketingStockReport/MarketingStockReportName'
import { TabMenu } from 'primereact/tabmenu';
import './MarketingStockPage.css'

export const MarketingStockPage = () => {

    const { id } = useParams();
    const [stockModel, setStockModel] = useState({});
    const [imageUrls, setImageUrls] = useState([]);
    const [fullDesriptionHtml, setFullDescriptionHtml] = useState("");
    const [startTime, setStartTime] = useState(""); 
    const [endTime, setEndTime] = useState(""); 
    const [stockTypeId, setStockTypeId] = useState(null);
    const [productList, setProductList] = useState([]);
    const [setListWithProductsList, setSetListWithProductsList] = useState([]);

    const [reportModel, setReportModel] = useState(null)
    const [menuItems, setMuneItems] = useState([{label:'Продукти', icon: 'pi pi-th-large', name:'products'}])
    const [menuTabActiveIndex, setMenuTabActiveIndex] = useState(0);
    const [menuTabActiveName, setMenuTabActiveName] = useState("products")

    const [fileList, setFileList] = useState([]);
    const [fileItems, setFileItems] = useState([])

    const {cart, getCart} = useCartContext();
    const {viewPortWidth,viewPortHeight} = useWindowDimensions();
    const toast = useRef(null);

    const [isLoading, setIsLoading] = useState(true)

    const galleria = useRef(null);
    const imageInfoWrapper = useRef(null);
    const secondWrapper = useRef(null);


    const responsiveOptions = [
        {
            breakpoint: '991px',
            numVisible: 4
        },
        {
            breakpoint: '767px',
            numVisible: 3
        },
        {
            breakpoint: '800px',
            numVisible: 1
        }
    ];
    const itemTemplate = (item) => {
        return <Image src={item}  style={{display: 'block', maxHeight: '95vh' }} />
    }

    const downLoadFile = async (id) => {
        setIsLoading(true);
        const {data} = await marketingStockAPI.loadMarketingStockFileById(id);
        let resp = JSON.parse(data);


        if(resp.isSucccess){

            const downloadFileObject = resp.data;
            fetch(`data:${downloadFileObject.FileType};base64,${downloadFileObject.FileData}`)
            .then(res => res.blob())
            .then(blob => {
                // Создаем URL для Blob
                let url = window.URL.createObjectURL(blob);

                // Создаем ссылку для скачивания
                let a = document.createElement('a');
                a.href = url;
                a.download = downloadFileObject.DownloadName || 'download';
                document.body.appendChild(a);
                a.click();
                a.remove();
    });
        }
        else{
            
        }
        setIsLoading(false);
    } 

    const menuItemClickHandler = (fileId) => {
        if(!fileId){
            toast.current.clear();
            toast.current.show({
                severity: 'error',
                summary: 'Помилка',
                clearPrevious: true,
                detail: 'При завантаженні файлу сталася помилка. Зверніться до менеджера або у відділ турботи.',
                life: 3000
            });
            return;
        }
        downLoadFile(fileId)
    }

    const setStartEndDateFromString = (start, end) => {
        const minDateTime = "0001-01-01T00:00:00";
        if(start !== minDateTime && end !== minDateTime) {
            setStartTime(GetDateFromString(start))
            setEndTime(GetDateFromString(end))
        }
    }

    const calculateIsSetPresentInCart = async() => {
        if(stockModel && stockModel.IsSet){
            const stockModelNew = _.cloneDeep(stockModel);
            const cart = JSON.parse(getCart());
            const stockList = cart.Stocks;

            for (let setItem of stockModelNew.SetList){
                const foundStock = stockList.find(stock => stock.Id === stockModel.Id);
                if(foundStock){
                    const foundSet = foundStock.ProductSetList.find(p => p.id === setItem.Id);
                    setItem.isPresentIsCart = !!foundSet;
                }
            }

            if(stockModelNew.SetList.length) {
                setSetListWithProductsList(stockModelNew.SetList);
            }
        }
    }

    const sortProductsByPriceAndName = (products) => {
        const currentProductList = _.cloneDeep(products)

        currentProductList.sort((a, b) => {
            if (a.ProductStockPrice === null && b.ProductStockPrice !== null) {
                return 1;
            }
            if (a.ProductStockPrice !== null && b.ProductStockPrice === null) {
                return -1;
            }
            if (a.ProductStockPrice !== null && b.ProductStockPrice !== null) {
                if (a.ProductStockPrice < b.ProductStockPrice) {
                    return -1;
                }
                if (a.ProductStockPrice > b.ProductStockPrice) {
                    return 1;
                }
            }
            if (a.ProductName < b.ProductName) {
                return -1;
            }
            if (a.ProductName > b.ProductName) {
                return 1;
            }
            return 0;
        });

        return currentProductList;

    }

    const fetchMarketingStockData = async () => {
        if(id) {
            const {data} = await marketingStockAPI.getMarketingStockInfo(id)
            debugger
            let resp = JSON.parse(data);

            if (resp.isSucccess) {
                setStockModel(resp.data)

                //продукты
                const sortProductList = sortProductsByPriceAndName(resp.data.Products)
                setProductList(sortProductList)

                //фото
                let urls = resp.data.OriginalImageUrls
                setImageUrls(urls);
                
                //stockType
                setStockTypeId(resp.data.MarketingStockTypeId)

                //report
                let stockReportModel = resp.data.ReportModel
                if(stockReportModel){
                    debugger
                    setReportModel(stockReportModel)

                    //menu model
                    if(stockReportModel.ReportObject.length > 0){
                        setMuneItems([{label:'Продукти', icon: 'pi pi-th-large', name:'products'}, {label:'Звіт', icon: 'pi pi-chart-bar', name:'report'}])
                    }
                }

                //files
                const files = resp.data.Files
                if(files.length){
                    setFileList(files);
                }
                else{
                    setFileList([]);
                }
                setStartEndDateFromString(resp.data.StartTime, resp.data.EndTime)
            }
            setIsLoading(false);
        }
    }

    const onMenuTabChange = (item) => {
        debugger
        const itemName = item.value.name;
        setMenuTabActiveName(itemName)
        setMenuTabActiveIndex(item.index)
    } 

    useEffect(() => {
        fetchMarketingStockData().then();
    },[])

    useEffect(() => {
        calculateIsSetPresentInCart().then();
    },[cart, stockModel])

    return (
        <div className={styles.marketingStockPage}>
            {isLoading ? <div>
                <SpinnerUA />
            </div> : null}
            <Toast ref={toast}></Toast>

            {viewPortWidth > 800 &&
                <Galleria  ref={galleria} value={imageUrls} responsiveOptions={responsiveOptions}
                           style={{maxWidth: '80%', maxHeight: '95vh', marginRight: '1rem', borderRadius: '1rem', backgroundColor: '#fff' }}
                           item={itemTemplate} fullScreen circular  showItemNavigators showItemNavigatorsOnHover showIndicators showIndicatorsOnItem={true}   showThumbnails={false} />
            }

            {!_.isEmpty(stockModel) ?
                <div ref={imageInfoWrapper} className={styles.imageInfoWrapper} id='imageInfoWrapper'>


                        {imageUrls.length > 0 ? <Image className={styles.image}  src={imageUrls[0]} onClick={() => galleria.current.show()} /> : <Image className={styles.image}  src={noPhoto} onClick={() => galleria.current.show()} />}


                    <div className={styles.info}>
                        <div className={styles.descriptionWrapper}>
                            <div className={`${styles.descriptionDateWrapper}`}>
                                <div className={`p-card-title ${styles.descriptionTitle}`}>{stockModel.Name}</div>
                                {reportModel && reportModel.ReportName !== ShellPremiumClubName && <div className={`p-card-title ${styles.stockDate}`}><span>{startTime} - {endTime}</span></div>}
                            </div>
                            <div dangerouslySetInnerHTML={{ __html: stockModel.FullDescription }} className={styles.descriptionText}></div>
                            {fileList.length>0 ? <div style={{paddingLeft:'20px', borderTop: 'solid 1px #eaebee'}}>
                                <span style={{color:'#495057', fontWeight:'600'}}>Файли:</span>
                                <div style={{display:'flex', flexDirection:'row', flexWrap: 'wrap', justifyContent: 'flex-start', marginBottom:'10px', marginLeft:'10px' }}>
                                    {fileList.map((file, index) =>
                                        <span key={file.Id+'key'} id= {file.Id}>
                                            <div style={{display:'flex', flexDirection:'row', alignItems:'center', marginRight:'35px'}}>
                                                <span>{file.DisplayName}</span>
                                                <Button icon="pi pi-download" style={{marginLeft:'1px'}} rounded text severity="info" aria-label="Favorite"  onClick={() => {menuItemClickHandler(file.Id)}} />
                                            </div>
                                        </span>
                                    )}
                                </div>
                            </div>
                            : null}
                        </div>
                </div>

            </div> : null}

            <div className='stockTabMenu'>
                <TabMenu model={menuItems}  activeIndex={menuTabActiveIndex} onTabChange={onMenuTabChange}/>
            </div>

            {menuTabActiveName === 'report' &&
                <MarketingStockReportWrapper reportModel={reportModel} />
            }

            {menuTabActiveName === "products" ? 
            <div>
                {!isLoading ? <MarketingStockCalculator stockId={id} stockTypeId={stockTypeId} /> : null}

                {/* {Не комплект} */}
                {productList.length > 0 && !stockModel.IsSet ? <div className={styles.productsWrapper}>
                    {productList.map((product, index) => <MarketingStockProductMobileView
                        key={product.ProductName + product.ProductNumber + index}
                        id={product.Id}
                        balance={product.TotalBalance}
                        deliveryDate={product.DeliveryDate}
                        productCountFromList={productList.length}
                        index={index}
                        stockId={id}
                        stockName={stockModel.Name}
                        productNumber={product.ProductNumber}
                        productName={product.ProductName}
                        reccomendPrice={product.ReccomendPrice}
                        totalBalance={product.TotalBalance}
                        totalAmount={product.TotalAmount}
                        smallImageUrl={product.SmallImageUrl}
                        originalImageUrl={product.OriginalImageUrl}
                        productPrice={product.ProductPrice}
                        productStockPrice={product.ProductStockPrice}
                        productPriceList={product.ProductPriceList}
                        toast={toast}
                    />)}
                </div> : null}

                {/* {Комплект} */}
                {stockModel.IsSet && setListWithProductsList.length > 0 ? <MarketingStockSetWrapper setListWithProduct={setListWithProductsList} stockId={id} stockModel={stockModel} toast={toast} /> : null} 
            </div>
            : null}
        </div>
    )


}